import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import * as CONSTANTS from '../constants';
import { ModalContext } from '../context/modal';

const SpinnerWrap = styled.div`
    display:block;
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: ${props => (props.darkMode === true) ? `${CONSTANTS.darkModeBackground}`
    : `${CONSTANTS.white}`};
`;

const animate = keyframes`
    0% {
        box-shadow: -60px 40px 0 2px #2f2f2f, -30px 40px 0 0 rgba(47, 47, 47, 0.2), 0 40px 0 0 rgba(47, 47, 47, 0.2), 30px 40px 0 0 rgba(47, 47, 47, 0.2), 60px 40px 0 0 rgba(47, 47, 47, 0.2);
    }

    25% {
        box-shadow: -60px 40px 0 0 rgba(47, 47, 47, 0.2), -30px 40px 0 2px #2f2f2f, 0 40px 0 0 rgba(47, 47, 47, 0.2), 30px 40px 0 0 rgba(47, 47, 47, 0.2), 60px 40px 0 0 rgba(47, 47, 47, 0.2);
    }

    50% {
        box-shadow: -60px 40px 0 0 rgba(47, 47, 47, 0.2), -30px 40px 0 0 rgba(47, 47, 47, 0.2), 0 40px 0 2px #2f2f2f, 30px 40px 0 0 rgba(47, 47, 47, 0.2), 60px 40px 0 0 rgba(47, 47, 47, 0.2);
    }

    75% {
        box-shadow: -60px 40px 0 0 rgba(47, 47, 47, 0.2), -30px 40px 0 0 rgba(47, 47, 47, 0.2), 0 40px 0 0 rgba(47, 47, 47, 0.2), 30px 40px 0 2px #2f2f2f, 60px 40px 0 0 rgba(47, 47, 47, 0.2);
    }

    100% {
        box-shadow: -60px 40px 0 0 rgba(47, 47, 47, 0.2), -30px 40px 0 0 rgba(47, 47, 47, 0.2), 0 40px 0 0 rgba(47, 47, 47, 0.2), 30px 40px 0 0 rgba(47, 47, 47, 0.2), 60px 40px 0 2px #2f2f2f;
    }
`;

const animateDarkMode = keyframes`
    0% {
        box-shadow: -60px 40px 0 2px #fff, -30px 40px 0 0 rgba(255, 255, 255, 0.2), 0 40px 0 0 rgba(255, 255, 255, 0.2), 30px 40px 0 0 rgba(255, 255, 255, 0.2), 60px 40px 0 0 rgba(255, 255, 255, 0.2);
    }

    25% {
        box-shadow: -60px 40px 0 0 rgba(255, 255, 255, 0.2), -30px 40px 0 2px #fff, 0 40px 0 0 rgba(255, 255, 255, 0.2), 30px 40px 0 0 rgba(255, 255, 255, 0.2), 60px 40px 0 0 rgba(255, 255, 255, 0.2);
    }

    50% {
        box-shadow: -60px 40px 0 0 rgba(255, 255, 255, 0.2), -30px 40px 0 0 rgba(255, 255, 255, 0.2), 0 40px 0 2px #fff, 30px 40px 0 0 rgba(255, 255, 255, 0.2), 60px 40px 0 0 rgba(255, 255, 255, 0.2);
    }

    75% {
        box-shadow: -60px 40px 0 0 rgba(255, 255, 255, 0.2), -30px 40px 0 0 rgba(255, 255, 255, 0.2), 0 40px 0 0 rgba(255, 255, 255, 0.2), 30px 40px 0 2px #fff, 60px 40px 0 0 rgba(255, 255, 255, 0.2);
    }

    100% {
        box-shadow: -60px 40px 0 0 rgba(255, 255, 255, 0.2), -30px 40px 0 0 rgba(255, 255, 255, 0.2), 0 40px 0 0 rgba(255, 255, 255, 0.2), 30px 40px 0 0 rgba(255, 255, 255, 0.2), 60px 40px 0 2px #fff;
    }
`;

const animateDarkModeMixin = css`
    animation: ${animateDarkMode} 1s linear alternate infinite;
`;

const animateMixin = css`
    animation: ${animate} 1s linear alternate infinite;
`;

const SpinnerEl = styled.div`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    position: relative;
    
    ${props => (props.darkMode === true) ? animateDarkModeMixin
    : animateMixin};
    top: 50%;
    margin: -50px auto 0;
`;

export default class Spinner extends React.Component {
    render() {
        let spinnerItem = '';

        if(this.props.isVisible === true){
            spinnerItem = (
                <SpinnerWrap darkMode={this.context.darkMode}>
                    <SpinnerEl darkMode={this.context.darkMode} />
                </SpinnerWrap>
            );
        }

        return spinnerItem;
    }
}

Spinner.contextType = ModalContext;
